import PurchaseOrderList from '@/pages/purchase/purchaseOrder/list';
import PurchaseOrderDetail from '@/pages/purchase/purchaseOrder/detail';
import PurchaseOrderAdd from '@/pages/purchase/purchaseOrder/add';
import NonwheelOrderList from '@/pages/purchase/nonwheelOrder/list';
import { applyRoute } from '../const';

const purchaseRoutes = [
    {
        path: `${applyRoute}/purchase/purchaseOrder/list`,
        meta: {
            auth: ['purchase'],
            title: '采购单',
            cache: true,
        },
        component: PurchaseOrderList,
    },
    {
        path: `${applyRoute}/purchase/purchaseOrder/detail`,
        meta: {
            auth: ['purchase'],
            title: '采购单详情',
            cache: false,
        },
        component: PurchaseOrderDetail,
    },
    {
        path: `${applyRoute}/purchase/purchaseOrder/add`,
        meta: {
            auth: ['purchase'],
            title: '新增采购单',
            cache: false,
        },
        component: PurchaseOrderAdd,
    },
    {
        path: `${applyRoute}/purchase/nonwheelOrder/list`,
        meta: {
            auth: ['purchase'],
            title: '非轮订单',
            cache: true,
        },
        component: NonwheelOrderList,
    },
];

export { purchaseRoutes };
